import { message } from 'antd';
import * as Sentry from '@sentry/react';
import {
  createBearerAuthClient,
  setupErrorInterceptor,
  type ProcessedError,
  type ApiErrorContext,
} from '@raporgor/api-client';
import { API_URL } from '../config';

// Token key used in localStorage
const TOKEN_KEY = 'auth_token';
const USER_KEY = 'auth_user';

// Handle unauthorized (401) - redirect to login
const handleUnauthorized = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  window.location.href = '/login';
};

// Create the API client with bearer auth
export const apiClient = createBearerAuthClient(
  API_URL,
  TOKEN_KEY,
  handleUnauthorized
);

// Add custom error interceptor for UI notifications
setupErrorInterceptor(apiClient, {
  onError: (error: ProcessedError) => {
    // Show toast notification for errors
    if (error.severity === 'error') {
      message.error(error.message);
    } else if (error.severity === 'warning') {
      message.warning(error.message);
    }
  },
  reportToSentry: (axiosError, context?: ApiErrorContext) => {
    Sentry.captureException(axiosError, {
      extra: context ? { ...context } : undefined,
    });
  },
});
